import { FC } from 'react'

import DOMPurify from 'dompurify'
import { styled } from 'styled-components'

import { PoweredByPeach } from 'core/components'
import { useCompanyInfo } from 'core/stores'
import { onSurfaceVariant, primary } from 'core/styles'

type TermsAndConditionsProps = {
  consent: string
}

const TermsAndConditions: FC<TermsAndConditionsProps> = ({ consent }) => {
  const { showPoweredByPeach } = useCompanyInfo()

  return (
    <Wrapper>
      <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(consent) }} />

      {showPoweredByPeach && <PoweredByPeach />}
    </Wrapper>
  )
}

export default TermsAndConditions

const Wrapper = styled.div`
  color: ${onSurfaceVariant};

  a {
    color: ${primary};

    &:hover {
      text-decoration: underline;
    }
  }
`
